import { SkeletonLoader } from '@moniebook-web/components/atoms/skeleton-loader';

const SKELETON_ITEM_COUNT = 4;

const SKELETON_ITEM_KEYS = Array.from(
    { length: SKELETON_ITEM_COUNT },
    (_, index) => `skeleton-item-${index}`,
);

export function SwitchContentSkeleton() {
    return (
        <div>
            <div className='mx-8 mb-13 border-y border-y-headless-stroke px-16 py-10'>
                <SkeletonLoader width='100%' height='36px' borderRadius='8px' />
            </div>
            <div className='flex flex-col gap-8 px-8'>
                {SKELETON_ITEM_KEYS.map((key) => (
                    <div
                        key={key}
                        className='flex items-center gap-16 px-8 py-10'>
                        <SkeletonLoader
                            width='40px'
                            height='40px'
                            borderRadius='6px'
                        />
                        <div className='flex flex-1 flex-col gap-4'>
                            <SkeletonLoader
                                width='60%'
                                height='14px'
                                borderRadius='4px'
                            />
                            <SkeletonLoader
                                width='40%'
                                height='12px'
                                borderRadius='4px'
                            />
                        </div>
                    </div>
                ))}
            </div>
            <div className='px-8 pt-24'>
                <SkeletonLoader width='100%' height='36px' borderRadius='8px' />
            </div>
        </div>
    );
}
